<template>
  <div class="p-3">
    <b-row>
      <b-col cols="2">
        <div class="sg-badge" :class="getActiveSetting('profile')" @click="loadChild('profile')">
          Profile
        </div>
      </b-col>

      <b-col cols="2">
        <div class="sg-badge" :class="getActiveSetting('privacy')" @click="loadChild('privacy')">
          Privacy
        </div>
      </b-col>
      <b-col cols="3">
        <div class="sg-badge" :class="getActiveSetting('becomeaguider')" @click="loadChild('becomeaguider')">
          Become a Guider
        </div>
      </b-col>
    </b-row>

    <b-row>
      <Privacy v-if="setting_body === 'privacy'" :user="user" />

      <Profile v-if="setting_body === 'profile'" :user="user" />
      <BecomeAGuider v-if="setting_body === 'becomeaguider'" :user="user" />
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component
import Privacy from '@/components/MyAccount/Settings/Privacy'
import Profile from '@/components/MyAccount/Settings/Profile'
import BecomeAGuider from '@/components/MyAccount/Settings/BecomeAGuider'

// api call

export default {
  name: 'MyAccount_Setting',
  props: ['user'],
  components: {
    Privacy,
    Profile,
    BecomeAGuider
  },
  data () {
    return {
      setting_body: 'profile'
    }
  },
  methods: {
    // PREREQUISITES
    loadChild: function (param) {
      this.setting_body = param
    },
    getActiveSetting (property) {
      return {
        'on': property === this.setting_body
      }
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge {
  cursor: pointer;
}

.sg-badge:hover:not(.on) {
  background-color: #c2ccdc;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Setting/Setting.vue